import { createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../axiosInstance";

export const createNewScoringModel = createAsyncThunk(
    "ratings/createNewScoringModel",
    async ({ community, title, description, category_weightages, }, { rejectWithValue }) => {
        try {
            const response = await axiosInstance.post(
                "community/scoring-models",
                {
                    community, title, description, category_weightages,
                }
            );
            return response.data;
        } catch (error) {
            return rejectWithValue(
                error.response ? error.response.data : error.message
            );
        }
    }
);

export const fetchScoringModelsByCommunity = createAsyncThunk(
    "ratings/fetchScoringModelsByCommunity",
    async ({ communityId, search }, { rejectWithValue }) => {
        try {
            const response = await axiosInstance.get(
                `community/scoring-models-list/${communityId}`, {
                params: {
                    search: search ? search : "",
                }
            }
            );
            return response.data;
        } catch (error) {
            return rejectWithValue(
                error.response ? error.response.data : error.message
            );
        }
    }
);

export const deleteScoringModel = createAsyncThunk(
    "ratings/deleteScoringModel",
    async (modelId, { rejectWithValue }) => {
        try {
            const response = await axiosInstance.delete(`community/scoring-models/${modelId}/delete`);
            return response.data;
        } catch (error) {
            return rejectWithValue(
                error.response ? error.response.data : error.message
            );
        }
    }
);

export const fetchScoringModelsDetailById = createAsyncThunk(
    "ratings/fetchScoringModelsDetailById",
    async (modelId, { rejectWithValue }) => {
        try {
            const response = await axiosInstance.get(
                `community/scoring-models/${modelId}/`
            );
            return response.data;
        } catch (error) {
            return rejectWithValue(
                error.response ? error.response.data : error.message
            );
        }
    }
);

export const updateScoringModels = createAsyncThunk(
    "ratings/updateScoringModels",
    async ({ id, community, title, description, category_weightages }, { rejectWithValue }) => {
        try {
            const response = await axiosInstance.put(
                `community/scoring-models/${id}/`,
                {
                    community, title, description, category_weightages,
                }
            );
            return response.data;
        } catch (error) {
            return rejectWithValue(
                error.response ? error.response.data : error.message
            );
        }
    }
);

export const applyScoringModel = createAsyncThunk(
    "ratings/applyScoringModel",
    async ({ scoring_model, community_id }, { rejectWithValue }) => {
        try {
            const response = await axiosInstance.post(
                "community/apply-scoring-model",
                {
                    scoring_model, community_id
                }
            );
            return response.data;
        } catch (error) {
            return rejectWithValue(
                error.response ? error.response.data : error.message
            );
        }
    }
);

export const fetchRatingsOfAllCategories = createAsyncThunk(
    "ratings/fetchRatingsOfAllCategories",
    async (communityId, { rejectWithValue }) => {
        try {
            const response = await axiosInstance.get(
                `community/category-rating/${communityId}/`
            );
            return response.data;
        } catch (error) {
            return rejectWithValue(
                error.response ? error.response.data : error.message
            );
        }
    }
);

export const fetchOverallRating = createAsyncThunk(
    "ratings/fetchOverallRating",
    async (communityId, { rejectWithValue }) => {
        try {
            const response = await axiosInstance.get(
                `community/category-percentage/${communityId}/`
            );
            return response.data;
        } catch (error) {
            return rejectWithValue(
                error.response ? error.response.data : error.message
            );
        }
    }
);